module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-power-up-drongen-1.e0560f4a.jpg";